/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type AgentStateIcon_agent$ref = any;
type JobLink_job$ref = any;
export type JobStates = "ACCEPTED" | "ASSIGNED" | "BLOCKED" | "BLOCKED_FAILED" | "BROKEN" | "CANCELED" | "CANCELING" | "EXPIRED" | "FINISHED" | "LIMITED" | "LIMITING" | "PENDING" | "RUNNING" | "SCHEDULED" | "SKIPPED" | "TIMED_OUT" | "TIMING_OUT" | "UNBLOCKED" | "UNBLOCKED_FAILED" | "WAITING" | "WAITING_FAILED" | "%future added value";
import type { FragmentReference } from "relay-runtime";
declare export opaque type AgentRow_agent$ref: FragmentReference;
declare export opaque type AgentRow_agent$fragmentType: AgentRow_agent$ref;
export type AgentRow_agent = {|
  +id: string,
  +hostname: ?string,
  +metaData: ?$ReadOnlyArray<string>,
  +name: string,
  +organization: ?{|
    +slug: string
  |},
  +clusterQueue: ?{|
    +key: string,
    +cluster: ?{|
      +uuid: string,
      +name: string,
    |},
    +uuid: string,
  |},
  +public: boolean,
  +isRunningJob: boolean,
  +job: ?{|
    +state?: JobStates,
    +$fragmentRefs: JobLink_job$ref,
  |},
  +uuid: string,
  +version: ?string,
  +versionHasKnownIssues: boolean,
  +$fragmentRefs: AgentStateIcon_agent$ref,
  +$refType: AgentRow_agent$ref,
|};
export type AgentRow_agent$data = AgentRow_agent;
export type AgentRow_agent$key = {
  +$data?: AgentRow_agent$data,
  +$fragmentRefs: AgentRow_agent$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "uuid",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AgentRow_agent",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hostname",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "metaData",
      "storageKey": null
    },
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Organization",
      "kind": "LinkedField",
      "name": "organization",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "slug",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ClusterQueue",
      "kind": "LinkedField",
      "name": "clusterQueue",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "key",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Cluster",
          "kind": "LinkedField",
          "name": "cluster",
          "plural": false,
          "selections": [
            (v1/*: any*/),
            (v0/*: any*/)
          ],
          "storageKey": null
        },
        (v1/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "public",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isRunningJob",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "job",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "state",
              "storageKey": null
            }
          ],
          "type": "JobTypeCommand",
          "abstractKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "JobLink_job"
        }
      ],
      "storageKey": null
    },
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "version",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "versionHasKnownIssues",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AgentStateIcon_agent"
    }
  ],
  "type": "Agent",
  "abstractKey": null
};
})();
// prettier-ignore
(node/*: any*/).hash = '8790b0ec952bf13e2832c363a23eb153';

module.exports = node;
